import { useFormContext, useFormState, useWatch } from 'react-hook-form'
import { UploadField, TextField } from '@ui/forms'

const FormFields = () => {
  const currentTitle = useWatch({ name: 'title' })
  const { setValue } = useFormContext()
  const { defaultValues } = useFormState()

  return (
    <>
      <TextField name="title" placeholder="Titel" />
      <TextField name="comment" placeholder="Kommentar" multiline rows={3} />
      <UploadField
        name="file"
        accept={{ 'application/pdf': [] }}
        onSelect={file => {
          if (currentTitle === defaultValues?.title) {
            setValue('title', file.name)
          }
        }}
      />
    </>
  )
}

export default FormFields
